import {Stack, useColorScheme} from '@mui/material';

export const ErrorTooltip = ({validationError}: {validationError: string | null}) => {
    const {colorScheme} = useColorScheme();
    const isLight = colorScheme === 'light';
    return (
        <>
            {validationError && (
                <Stack
                    sx={{
                        backgroundColor: isLight ? '#fff' : '#363636',
                        padding: 1,
                        borderRadius: 1,
                        color: 'var(--mui-palette-text-primary)',
                        minWidth: '100%',
                        boxShadow:
                            '0px 4px 16px rgba(0, 0, 0, 0.24), 0px 2px 4px rgba(0, 0, 0, 0.12)',
                    }}
                >
                    {validationError}
                </Stack>
            )}
        </>
    );
};
